import { render, staticRenderFns } from "./MinYueDaSai.vue?vue&type=template&id=4e1b8924&scoped=true&"
import script from "./MinYueDaSai.vue?vue&type=script&lang=js&"
export * from "./MinYueDaSai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1b8924",
  null
  
)

export default component.exports